import { useQuery } from "react-query";
import { getJudgeExhibitorIdByUserId } from "../../services/scientific/exhibitor";
import { key_userId } from "../../utils/constants";


export const useGetJudgeExhibitorByUserIdQuery = (id: string, options:any=null) =>
  useQuery(
    [key_userId, JSON.stringify(id)],
    () => getJudgeExhibitorIdByUserId(id),
    options?{...options}:{}
  );
